import styled, { css } from 'styled-components'

import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`

export const Section = styled.div`
  margin-bottom: 32px;
`

export const SectionTitle = styled.h2`
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 24px;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: AzoSans;
          font-weight: 600;
          color: ${theme.colors.lightGold};
        `
      : css`
          font-family: 'Futura Std';
          font-weight: 700;
          color: ${theme.colors.white};
        `}
`

export const NoResultsContainer = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
`

export const NoResults = styled.h2`
  font-size: 28px;
  line-height: 32px;
  margin-bottom: 24px;
  text-align: center;
  max-width: 500px;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: AzoSans;
          font-weight: 600;
          color: ${theme.colors.lightGold};
        `
      : css`
          font-family: 'Futura Std';
          font-weight: 650;
          color: ${theme.colors.white};
        `}
`
